import { render, staticRenderFns } from "./MsgLists.vue?vue&type=template&id=3e00d5d5&scoped=true"
import script from "./MsgLists.vue?vue&type=script&lang=js"
export * from "./MsgLists.vue?vue&type=script&lang=js"
import style0 from "./MsgLists.vue?vue&type=style&index=0&id=3e00d5d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e00d5d5",
  null
  
)

export default component.exports